import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { GeneralParameters } from 'src/app/constants/general-parameters-constans';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { FormatsEnums } from 'src/app/enum/formats-enums';
import { InventoryOutputStateEnums } from 'src/app/enum/inventory-output-state-enums';
import { InventoryOutputTypeEnums } from 'src/app/enum/inventory-output-type-enums';
import { FormatModel } from 'src/app/models/formats/format.model';
import { InventoryOutputModel } from 'src/app/models/inventory/inventory-output.model';
import { OrderModel } from 'src/app/models/preliminaries/order.model';
import { SalesRemissionPrintModel } from 'src/app/models/print/inventory/sales-remission-print.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { OrderSelectionTableModel } from 'src/app/models/tables/preliminaries/order-selection-table.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { FormatService } from 'src/app/services/formats/format.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { FormControlStateService } from 'src/app/services/global-services/form-control-state.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { SalesRemissionService } from 'src/app/services/inventory/sales-remission.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { OrderService } from 'src/app/services/preliminaries/order.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-sales-remission',
  templateUrl: './register-sales-remission.component.html',
  styleUrls: ['./register-sales-remission.component.scss'],
  standalone: false
})
export class RegisterSalesRemissionComponent implements OnInit {

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly branchService = inject(BranchService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly confirmDialogService = inject(ConfirmDialogService);
  private readonly dateConverterService = inject(DateConverterService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly formControlStateService = inject(FormControlStateService);
  private readonly formatService = inject(FormatService);
  private readonly headerService = inject(HeaderService);
  private readonly inventoryService = inject(InventoryService);
  private readonly location = inject(Location);
  private readonly orderService = inject(OrderService);
  private readonly router = inject(Router);
  private readonly salesRemissionService = inject(SalesRemissionService);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly userAuthenticatedService = inject(UserAuthenticatedService);
  private readonly windowService = inject(WindowService);

  @ViewChild('orderSelection') orderSelectionModalComponent?: CustomModalComponent | null = null;
  ascendantOrder: boolean = true;
  branchId: number = 0;
  clientStateId: number = 0;
  codeNameClient: string = '';
  codeNameCostCenter: string = '';
  columnSortOrder: string | null = null;
  companyId: number = 0;
  componentTableSelection = CustomTableSelectComponent;
  conceptId: number = 0;
  constructionSiteStateId: number = 0;
  dataOrder: PagedResponseModel<OrderSelectionTableModel> = new PagedResponseModel<OrderSelectionTableModel>();
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  filtersOrder: ColumnResponseModel[] = [];
  formSalesRemission: FormGroup = new FormGroup({});
  formatModel: FormatModel = new FormatModel();
  hasQuantityInZero: boolean = false;
  headerOrder: ColumnResponseModel[] = [];
  invoiceConsecutive: number = 0;
  iconState: string = '';
  inventoryClassCode: number = 0;
  inventoryId: number = 0;
  inventoryOutputId: number = 0;
  inputsForOrdersSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: false,
    filters: [],
  });
  isOpened: string | undefined = undefined;
  limitOrder: number = 10;
  listBranch: any[] = [];
  listClient: any[] = [];
  listCostCenter: any[] = [];
  listInventory: any[] = [];
  listInventoryOutputType: any[] = [];
  listTransporters: any[] = [];
  listVehicles: any[] = [];
  nameWindow: string = 'Captura Remisiones de Venta';
  output$ = new Subject<any>();
  orderConsecutive: number = 0;
  pageOrder: number = 1;
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  salesRemissionContract: InventoryOutputModel = new InventoryOutputModel();
  salesRemissionPrintModel: SalesRemissionPrintModel = new SalesRemissionPrintModel();
  severityState: string = "danger";
  stateOpen: number = InventoryOutputStateEnums.open;
  stateText: string = '';
  subscription: Subscription;
  swOrderModule: boolean = false;
  transporterId: number = 0;
  titleState: string = '';
  url: string = 'sales-remission';
  vehicleId: number = 0;

  async ngOnInit() {
    this.validateForm(new InventoryOutputModel());
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChange(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.inventoryOutputId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async blockSalesRemission(value: boolean) {
    if (this.salesRemissionContract.inventoryOutputId != 0 && this.salesRemissionContract.inventoryOutputId != null) {
      const inventoryOutputId = this.salesRemissionContract.inventoryOutputId;
      try {
        this.salesRemissionContract = await firstValueFrom(this.salesRemissionService.blockSalesRemission(inventoryOutputId));
        this.validateForm(this.salesRemissionContract);
      } catch (error) {
        this.formSalesRemission.controls["swBlock"].setValue(!value);
        console.error('Error al bloquear la remisión de venta.', error);
      }
    } else {
      this.formSalesRemission.controls["swBlock"].setValue(!value);
    }
  }

  async deleteSalesRemission() {
    if (this.salesRemissionContract.inventoryOutputId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        `Debe crear el encabezado de la remisión de venta.`
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para eliminar la remisión de venta. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    const accepted = await this.confirmDialogService.confirm('¿Realmente desea eliminar la remisión de venta?');
    if (accepted) {
      try {
        await firstValueFrom(this.salesRemissionService.deleteSalesRemission(this.inventoryOutputId));
        this.createNewSalesRemission();
        this.toastHandlerService.showToast(
          'success',
          'La remisión de venta fue eliminada exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar la remisión de venta.', error);
      }
    }
  }

  async changeBranch(branchId: number, loadAllLists: boolean) {
    this.branchId = branchId;
    if (loadAllLists) {
      await this.getAllLists();
    } else {
      await this.getAllLists('transporters', 'vehicles');
      this.resetContract();
    }
  }

  async changeConsecutive() {
    const inventoryId = this.formSalesRemission.get("inventoryId")?.value;
    const branchId = this.formSalesRemission.get("branchId")?.value;
    let consecutive = this.formSalesRemission.get("consecutive")?.value;
    if (inventoryId === null || inventoryId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un inventario.'
      );
      return;
    } else if (branchId === null || branchId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (consecutive <= 0) {
      consecutive = 0;
    }
    if (consecutive === 0) {
      this.salesRemissionContract.branchId = branchId;
      this.salesRemissionContract.inventoryId = inventoryId;
      this.validateForm(this.salesRemissionContract);
      this.location.replaceState(`/${this.url}/register`);
    } else {
      try {
        this.salesRemissionContract = await firstValueFrom(
          this.salesRemissionService.getSalesRemissionByKeysAsync(inventoryId, branchId, consecutive)
        );
        this.inventoryOutputId = this.salesRemissionContract.inventoryOutputId;
        this.validateForm(this.salesRemissionContract);
        this.location.replaceState(`/${this.url}/register/${this.inventoryOutputId}`);
      } catch (error) {
        this.createNewSalesRemission();
        console.error('Error al obtener la remisión de venta por claves.', error);
      }
    }
  }

  async changeInventory(inventoryId: number) {
    this.inventoryId = inventoryId;
    this.branchId = this.formSalesRemission.get("branchId")?.value;
    this.salesRemissionContract = new InventoryOutputModel();
    this.codeNameClient = '';
    this.codeNameCostCenter = '';
    this.inventoryOutputId = 0;
    this.salesRemissionContract.branchId = this.branchId;
    this.salesRemissionContract.conceptId = this.conceptId;
    this.salesRemissionContract.inventoryId = this.inventoryId;
    this.salesRemissionContract.inventoryOutputTypeId = InventoryOutputTypeEnums.salesRemission;
    this.validateForm(this.salesRemissionContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async changeState() {
    if (!this.inventoryOutputId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una remisión de venta.'
      );
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para modificar remisiones de venta. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    try {
      const response = await firstValueFrom(this.salesRemissionService.setSalesRemissionState(
        this.inventoryOutputId
      ));
      this.salesRemissionContract = response;
      this.validateForm(this.salesRemissionContract);
      this.toastHandlerService.showToast(
        'success',
        'El estado de la remisión de venta se modificó exitosamente.'
      );
    } catch (error) {
      console.error('Error al cambiar el estado de la remisión de venta.', error);
    }
  }

  async createNewSalesRemission() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para crear una remisión de venta. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.resetContract();
    if (this.swOrderModule) {
      this.codeNameClient = '';
      this.codeNameCostCenter = '';
      this.openOrderSelectionModal();
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) {
      window.print();
    }
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'inventories' | 'transporters' | 'vehicles' | 'clients'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranch = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        inventories: async () => {
          this.listInventory = await firstValueFrom(
            this.salesRemissionService.getAllInventoriesForSelectAsync()
          );
        },
        transporters: async () => {
          this.listTransporters = await firstValueFrom(
            this.salesRemissionService.getAllTransporterForSelect(this.branchId)
          );
          const defaultTransporter = this.listTransporters.find(x => x.isDefault);
          if (defaultTransporter) {
            this.transporterId = defaultTransporter.value;
          }
        },
        vehicles: async () => {
          this.listVehicles = await firstValueFrom(
            this.salesRemissionService.getAllVehicleForSelect(this.branchId)
          );
          const defaultVehicle = this.listVehicles.find((x: any) => x.isDefault);
          if (defaultVehicle) {
            this.vehicleId = defaultVehicle.value;
          }
        },
        clients: async () => {
          if (!this.swOrderModule) {
            this.listClient = await firstValueFrom(
              this.salesRemissionService.getAllClientsForSelectAsync()
            );
            this.cdr.detectChanges();
          }
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.inventories(),
          lists.transporters(),
          lists.vehicles(),
          lists.clients()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  getButtonClick(buttonClick: any) {
    const inventoryId = this.formSalesRemission.get("inventoryId")?.value;
    const branchId = this.formSalesRemission.get("branchId")?.value;
    let consecutive = this.formSalesRemission.get("consecutive")?.value;

    if (inventoryId === null || inventoryId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione un inventario.'
      );
      return;
    } else if (branchId === null || branchId === 0) {
      this.toastHandlerService.showToast(
        'warning',
        'Seleccione una sucursal.'
      );
      return;
    } else if (consecutive === null || consecutive === undefined) {
      consecutive = 0;
    }
    this.handleOrderNavigation(buttonClick, branchId, inventoryId, consecutive);
  }

  async getGeneralParametersByCompany() {
    this.userAuthenticatedService.generalParameterObservable.subscribe(response => {
      this.swOrderModule = response.some(x => x.name === GeneralParameters.orderModule);
    });
  }

  async getClient(clientId: number | null) {
    const previousClientId = this.salesRemissionContract.clientId;
    if (previousClientId === clientId) { return; }
    if (clientId === null && this.quantityDetails != 0) {
      setTimeout(() => this.formSalesRemission.controls["clientId"].patchValue(previousClientId));
      this.toastHandlerService.showToast(
        'error',
        'No puede limpiar el cliente si la remisión de venta tiene detalle.'
      );
      return;
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = branch.branchId;
      await this.getAllLists();
    } catch (error) {
      this.branchId = 0;
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getCompanyByUserAuthenticatedAsync() {
    const company = (await firstValueFrom(
      this.userAuthenticatedService.companyObservable.pipe(
        filter((company) => company && company.companyId !== 0)
      )
    ));
    this.companyId = company.companyId;
  }


  async getFirstInventoryByCompanyAuthenticated() {
    try {
      const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyAuthenticatedAsync());
      this.inventoryId = response.inventoryId;
      await this.getFirstBranchByUserAuthenticated();
    } catch (error) {
      console.error('Error al obtener el primer inventario por empresa autenticada.', error);
    }
  }

  async getClientForSelect(clientId: number) {
    try {
      const client = await firstValueFrom(this.salesRemissionService.getClientForSelect(clientId));
      this.codeNameClient = client.label;
      this.clientStateId = client.clientStateId;
    } catch (error) {
      console.error('Error al obetner los datos del cliente.', error);
    }
  }

  async getSalesRemissionRelatedConsecutives(inventoryOutputId: number) {
    try {
      const response = await firstValueFrom(this.salesRemissionService.getSalesRemissionRelatedConsecutives(inventoryOutputId));
      this.invoiceConsecutive = response.invoiceConsecutive ?? 0;
      this.orderConsecutive = response.orderConsecutive ?? 0;
    } catch (error) {
      console.error('Error al obtener los consecutivos relacionados con la remisión de venta.', error);
    }
  }

  async getCostCenterForSelect(costCenterId: number) {
    try {
      const costCenter = await firstValueFrom(this.salesRemissionService.getCostCenterForSelect(costCenterId));
      this.codeNameCostCenter = costCenter.label;
      this.constructionSiteStateId = costCenter.constructionSiteStateId;
    } catch (error) {
      console.error('Error al obetner los datos del centro de costos.', error);
    }
  }

  async getColumnsOrders() {
    try {
      if (this.headerOrder.length != 0) { return; }
      this.headerOrder = await firstValueFrom(this.orderService.getColumnsForOrderSelection());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de pedidos.', error);
    }
  }

  async getConceptForSale() {
    try {
      const response = await firstValueFrom(this.salesRemissionService.getConceptForSaleAsync());
      this.conceptId = response.value;
    } catch (error) {
      this.conceptId = 0;
      console.error('Error al obtener los conceptos de inventario.', error);
    }
  }

  async getInventoryById() {
    try {
      const response = await firstValueFrom(this.inventoryService.getInventoryById(this.inventoryId));
      return response.inventoryClassId;
    } catch (error) {
      console.error('Error al obtener el inventario por Id.??', error);
      throw error;
    }
  }

  async getFormatByCompanyAndCode() {
    if (this.formatModel.formatId == 0) {
      try {
        this.formatModel = await firstValueFrom(this.formatService.getFormatByCompanyAndCode(this.companyId!, FormatsEnums.salesRemission));
      } catch (error) {
        console.error('Error al obtener el formato por compañía.', error);
      }
    }
  }

  goToBack(event: Event) {
    event.preventDefault();
    this.router.navigate([`/${this.url}`]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      if (!this.permissionUpdatable) {
        this.disabledForm = true;
        this.disabledDetail = true;
        setTimeout(() => this.formSalesRemission.disable());
      }
    } catch (error) {
      this.permissionUpdatable = false;
      console.error('Error al obtener el permiso actualizable por URL.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas 
          de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    try {
      await Promise.all([
        this.getConceptForSale(),
        this.getPermissionPrint(),
        this.getPermissionProfileByUrl(),
        this.getGeneralParametersByCompany(),
        this.getCompanyByUserAuthenticatedAsync()
      ]);
    } catch (error) {
      console.error('Error al obtener permisos de perfil.', error);
    }
  }

  async getPermissionPrint() {
    try {
      const response = await firstValueFrom(this.salesRemissionService.getPermissionPrint());
      this.permissionPrint = response;
    } catch (error) {
      console.error('Error al obtener permisos de impresión.', error);
    }
  }

  async getSalesRemissionById() {
    try {
      const response = await firstValueFrom(this.salesRemissionService.getSalesRemissionById(this.inventoryOutputId));
      await this.changeBranch(response.branchId, true);
      this.inventoryId = response.inventoryId;
      this.inventoryOutputId = response.inventoryOutputId;
      this.salesRemissionContract = response;
      this.validateForm(this.salesRemissionContract);
    } catch (error) {
      console.error('Error al obtener la remisión de venta por Id.', error);
    }
  }

  async getSalesRemissionDependencies(inventoryOutputId: number, order: OrderModel | null, clientId?: number) {
    if (!inventoryOutputId || inventoryOutputId === 0) return;
    try {
      if (order && this.swOrderModule) {
        await Promise.all([
          this.getClientForSelect(clientId ?? 0),
          this.getCostCenterForSelect(order.costCenterId ?? 0)
        ]);
      }
      await this.getSalesRemissionRelatedConsecutives(inventoryOutputId);
    } catch (error) {
      console.error('Error al cargar las dependencias de la remisión de venta.', error);
    }
  }

  async getOrdersForSelection() {
    try {
      const response = await firstValueFrom(this.orderService.getOrdersForSelection(
        this.pageOrder, this.limitOrder, this.columnSortOrder, this.ascendantOrder, this.filtersOrder, this.branchId)
      );
      this.dataOrder = response;
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los pedidos', error);
    }
  }

  async getOrderById(orderId: number) {
    try {
      return await firstValueFrom(this.orderService.getOrderById(orderId));
    } catch (error) {
      console.error('Error al obtener el pedido.', error);
      return new OrderModel();
    }
  }

  async handleSelectedItem(selectedItem: any) {
    const [{ orderId, clientId }] = selectedItem;
    const order = await this.getOrderById(orderId);
    if (order) {
      const { orderId, dateOrder, orderTypeId, costCenterId, consecutive } = order;
      if (!await this.isCompatibleType(orderTypeId)) {
        return;
      }
      await Promise.all([
        this.getClientForSelect(clientId),
        this.getCostCenterForSelect(costCenterId)
      ]);
      this.orderConsecutive = consecutive;
      Object.assign(this.salesRemissionContract, {
        order: order,
        orderId: orderId,
        clientId: clientId,
        dateOutput: dateOrder
      });
      this.validateForm(this.salesRemissionContract);
    }
  }

  async handleInitialState() {
    if (this.inventoryOutputId !== null && this.inventoryOutputId !== 0) {
      await this.getSalesRemissionById();
    } else {
      await this.getFirstInventoryByCompanyAuthenticated();
      this.createNewSalesRemission();
    }
  }

  async handleOrderNavigation(buttonClick: any, branchId: number, inventoryId: number, consecutive: number) {
    const actionMap: Record<string, () => Promise<InventoryOutputModel>> = {
      first: () =>
        firstValueFrom(this.salesRemissionService.getFirstSalesRemissionByKeysAsync(inventoryId, branchId)),
      next: () =>
        firstValueFrom(this.salesRemissionService.getNextSalesRemissionByKeysAsync(inventoryId, branchId, consecutive)),
      previus: () =>
        firstValueFrom(this.salesRemissionService.getPreviusSalesRemissionByKeysAsync(inventoryId, branchId, consecutive)),
      last: () =>
        firstValueFrom(this.salesRemissionService.getLastSalesRemissionByKeysAsync(inventoryId, branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract();
    }
    try {
      const salesRemission = await action();
      this.salesRemissionContract = salesRemission;
      this.inventoryOutputId = salesRemission.inventoryOutputId;
      this.validateForm(this.salesRemissionContract);
      this.location.replaceState(`/${this.url}/register/${this.inventoryOutputId}`);
    } catch (error) {
      console.error(`Error al obtener la remisión de venta (${buttonClick.target.id}).`, error);
    }
  }

  async isCompatibleType(orderTypeId: number): Promise<boolean> {
    const inventoryClassId = await this.getInventoryById();
    const isCompatible = (inventoryClassId === 1 && orderTypeId === 3) ||
      (inventoryClassId === 4 && orderTypeId === 2);
    if (!isCompatible) {
      this.toastHandlerService.showToast(
        'warning',
        `El tipo de pedido no es compatible con el inventario definido en la remisión de venta.`
      );
      return false;
    }
    return true;
  }

  async openOrderSelectionModal() {
    this.filtersOrder = [];
    this.updateInputs();
    await this.getColumnsOrders();
    await this.getOrdersForSelection();
    this.orderSelectionModalComponent?.show();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersOrder = this.removeDuplicates(filters);
    this.filtersOrder.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageOrder = event.page;
    this.limitOrder = event.pageSize;
    this.columnSortOrder = event.sortField || null;
    this.ascendantOrder = event.sortOrder === 1;
    await this.getOrdersForSelection();
  }

  async printPage() {
    if (!this.inventoryOutputId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear una remisión de venta.'
      );
      return;
    }
    if (this.hasQuantityInZero) {
      this.toastHandlerService.showToast(
        'warning',
        'No puede imprimir la remisión de venta si tiene detalles con cantidades en cero.'
      );
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para imprimir remisión de venta. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    await this.getFormatByCompanyAndCode();
    this.salesRemissionPrintModel = await firstValueFrom(this.salesRemissionService.getSalesRemissionByKeysForPrintAsync(
      this.inventoryOutputId, this.salesRemissionContract.inventoryId, this.salesRemissionContract.branchId, 0
    ));
    this.toastHandlerService.clearAllToasts();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersOrder = this.filtersOrder.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersOrder.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  resetContract() {
    this.quantityDetails = 0;
    this.inventoryOutputId = 0;
    this.orderConsecutive = 0;
    this.invoiceConsecutive = 0;
    this.salesRemissionContract = new InventoryOutputModel();
    this.salesRemissionContract.consecutive = 0;
    this.salesRemissionContract.branchId = this.branchId;
    this.salesRemissionContract.conceptId = this.conceptId;
    this.salesRemissionContract.inventoryId = this.inventoryId;
    this.salesRemissionContract.vehicleId = this.vehicleId;
    this.salesRemissionContract.transporterId = this.transporterId;
    this.salesRemissionContract.inventoryOutputTypeId = InventoryOutputTypeEnums.salesRemission
    this.validateForm(this.salesRemissionContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async send() {
    this.validateFormControls();
    if (this.formSalesRemission.valid) {
      const modelInventoryOutput = this.formSalesRemission.getRawValue() as InventoryOutputModel;
      if (modelInventoryOutput.observation?.trim() === "") modelInventoryOutput.observation = null;
      if (this.inventoryOutputId == 0) {
        try {
          this.salesRemissionContract = await firstValueFrom(this.salesRemissionService.createSalesRemission(modelInventoryOutput));
          this.inventoryOutputId = this.salesRemissionContract.inventoryOutputId;
          this.validateForm(this.salesRemissionContract);
          this.toastHandlerService.showToast(
            'success',
            'La remisión de venta fue creada exitosamente.'
          );
          this.location.replaceState(`/${this.url}/register/${this.inventoryOutputId}`);
        } catch (error) {
          console.error('Error al crear la remisión de venta.', error);
        }
      } else {
        this.salesRemissionContract.conceptId = modelInventoryOutput.conceptId;
        this.salesRemissionContract.dateOutput = modelInventoryOutput.dateOutput;
        this.salesRemissionContract.observation = modelInventoryOutput.observation;
        this.salesRemissionContract.clientId = modelInventoryOutput.clientId;
        this.salesRemissionContract.vehicleId = modelInventoryOutput.vehicleId;
        this.salesRemissionContract.transporterId = modelInventoryOutput.transporterId;
        this.salesRemissionContract.transportValue = modelInventoryOutput.transportValue;
        try {
          this.salesRemissionContract = await firstValueFrom(this.salesRemissionService.updateSalesRemission(this.salesRemissionContract));
          this.validateForm(this.salesRemissionContract);
          this.toastHandlerService.showToast(
            'success',
            'La remisión de venta fue modificada exitosamente.'
          );
        } catch (error) {
          console.error('Error al actualizar la remisión de venta.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      inventoryId: {
        required: 'El campo Inventario es obligatorio.',
        min: 'Debes seleccionar un Inventario válido.'
      },
      branchId: {
        required: 'El campo Sucursal es obligatorio.',
        min: 'Debes seleccionar una Sucursal válida.'
      },
      inventoryOutputTypeId: {
        required: 'El campo Tipo es obligatorio.',
        min: 'Debes seleccionar un Tipo válido.'
      },
      conceptId: {
        required: 'El campo Concepto es obligatorio.',
        min: 'Debes seleccionar un Concepto válido.'
      },
      clientId: {
        required: 'El campo Cliente es obligatorio.',
        min: 'Debes seleccionar un Cliente válido.'
      },
      dateOutput: {
        required: 'La Fecha de la Salida es obligatoria.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach((control) => {
      const formControl = this.formSalesRemission.get(control);
      if (formControl && formControl.invalid && formControl.errors) {
        const messages = controlMessages[control];
        Object.keys(formControl.errors).forEach((errorKey) => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputs() {
    this.inputsForOrdersSelection$.next({
      headers: this.headerOrder,
      data: this.dataOrder,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: false,
      filters: this.filtersOrder,
    });
  }

  async updateFormState() {
    const stateConfig: any = {
      [InventoryOutputStateEnums.open]: {
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierto',
        disabledForm: false,
        disabledDetail: false,
        severityState: 'danger'
      },
      [InventoryOutputStateEnums.close]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrado',
        disabledForm: true,
        disabledDetail: true,
        severityState: 'success'
      }
    };
    const currentState = this.salesRemissionContract.inventoryOutputStateId;
    const config = stateConfig[currentState];
    this.salesRemissionContract.swBlock ? !config.isDisabled : config.isDisabled;
    if (config) {
      this.stateText = config.text;
      this.iconState = config.icon;
      this.titleState = config.title;
      this.disabledForm = config.isDisabled;
      this.disabledDetail = config.isDisabled;
      this.severityState = config.severityState;
    }
    if (this.salesRemissionContract.inventoryOutputStateId == InventoryOutputStateEnums.open && !this.salesRemissionContract.swBlock) {
      if (this.inventoryOutputId != 0) {
        setTimeout(() => this.formSalesRemission.controls["consecutive"].enable());
      } else {
        this.disabledDetail = true;
        setTimeout(() => this.formControlStateService.setControlState(
          this.formSalesRemission, ['swBlock', 'consecutive'], false
        ));
      }
    } else {
      setTimeout(() => this.formSalesRemission.disable());
      setTimeout(() => this.formControlStateService.setControlState(
        this.formSalesRemission, ['branchId', 'inventoryId', 'consecutive', 'swBlock'], true
      ));
      this.disabledDetail = true;
      this.disabledForm = true;
    }
  }

  async validateForm(salesRemission: InventoryOutputModel) {
    this.formSalesRemission = this.formBuilder.group({
      swBlock: [salesRemission.swBlock],
      orderId: [salesRemission.orderId],
      vehicleId: [salesRemission.vehicleId],
      consecutive: [salesRemission.consecutive],
      transporterId: [salesRemission.transporterId],
      costCenterId: [salesRemission.order?.costCenterId],
      observation: [salesRemission.observation, [Validators.maxLength(250)]],
      branchId: [salesRemission.branchId, [Validators.required, Validators.min(1)]],
      clientId: [salesRemission.clientId, [Validators.required, Validators.min(1)]],
      conceptId: [salesRemission.conceptId, [Validators.required, Validators.min(1)]],
      inventoryId: [salesRemission.inventoryId, [Validators.required, Validators.min(1)]],
      inventoryOutputTypeId: [salesRemission.inventoryOutputTypeId, [Validators.required, Validators.min(1)]],
      transportValue: [salesRemission.transportValue, [Validators.required, Validators.min(0), Validators.max(99999999999.99)]],
      dateOutput: [salesRemission.dateOutput ? this.dateConverterService.convertUtcToLocalDate(salesRemission.dateOutput)
        : null, [Validators.required]],
    });
    this.updateFormState();
    const { inventoryOutputId, clientId, order } = salesRemission;
    await this.getSalesRemissionDependencies(inventoryOutputId, order, clientId);
  }

  validateFormControls() {
    Object.keys(this.formSalesRemission.controls).forEach((key) => {
      const control = this.formSalesRemission.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
